module.exports = __webpack_public_path__ + "static/media/jquery.089f65dd.svg";